import React from 'react';

export function arrangeEvents(diastolic, systolic) {
    var result = systolic.map(function (el) {
        var o = Object.assign({}, el);
        o.type = 'systolic';
        return o;
    })
    var res = diastolic.map(function (el) {
        var o = Object.assign({}, el);
        o.type = 'diastolic';
        return o;
    })
    Array.prototype.push.apply(result, res);
    return result
}


// WEBPACK FOOTER //
// ./src/helpers/eventsHelper.js